import { OptionsSourcesClient } from '@n3oltd/karakoram.digital.sdk.options-sources'
import { serviceBaseUrl } from '@/lib/api/baseUrl'
import { createConfig } from '@/lib/api/config'
import { createHttp } from '@/lib/api/http'
import { projectOptions, type OptionsQuery, type PickerOption } from '@/lib/projectOptions'

interface CallOptions {
  token: string
  subscriptionCode: string
  signal?: AbortSignal
}

function client({ token, subscriptionCode, signal }: CallOptions): OptionsSourcesClient {
  return new OptionsSourcesClient(
    createConfig(token, subscriptionCode),
    serviceBaseUrl('digital'),
    createHttp(signal),
  )
}

export async function fetchOptions(
  opts: CallOptions,
  { source, group, searchText }: OptionsQuery,
): Promise<PickerOption[]> {
  const body = { source, group: group ?? undefined }
  const res =
    searchText === null
      ? await client(opts).getCommonOptionsSourceValues(body)
      : await client(opts).searchOptionsSourceValues({ ...body, searchText })
  return projectOptions(res)
}
